<template>
    
   <section class="landing-section landing-section--light">
      <div class="landing-container">
        <div class="landing-other-services">
          <h2 class="landing-section-title landing-section-title--dark">Other services</h2>
          <p class="landing-section-subtitle">
            We also offer other services that you can add to your portfolio, Get in touch if you would like to add any of these to your account.
          </p>

          <div class="landing-grid landing-grid--other">
            <ServiceCard
              v-for="service in completedServiceList"
              :key="service.id"
              :title="service.title"
              :description="service.description"
              variant="light-blue"
              :showArrow="false"
            />
          </div>

          <button class="landing-enquire-button" @click="handleEnquireClick">
            Enquire about services
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
</template>

<script setup>
import { ref, computed , onBeforeMount} from 'vue'
import ServiceCard from './ServiceCard.vue'
const completedServiceList = ref([])

onBeforeMount(async () => {
const loadCompletedServiceList = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        {
          id: 1,
          title: 'Data Tools',
          description: 'Manage your customer contact data channel preference and contact history'
        },
        {
          id: 2,
          title: 'Clarity Digital',
          description: 'Upload data and content, customise your templates, orchestrate delivery across channels'
        },
        {
          id: 3,
          title: 'Virtual Postroom',
          description: 'Upload data and content, customise your templates, orchestrate delivery across channels'
        },
        {
          id: 4,
          title: 'Web2Print',
          description: 'Web to print services'
        },
        {
          id: 5,
          title: 'Email Now',
          description: 'Send your document by email in a simple one-step process'
        }
      ])
    }, 1200)
  })
}
const handleEnquireClick = () => {
  console.log('Enquire button clicked - triggering PDF download')
  // TODO: Implement actual PDF download
  // For now, simulate download
  alert('PDF download will be triggered here')
}
const otherServicesData = await loadCompletedServiceList()
completedServiceList.value = otherServicesData

})
</script>


<style scoped>

.landing-section {
  padding: 3rem 0 3rem 0;
}

.landing-section--dark {
  background: linear-gradient(135deg, #1e3a5f 0%, #2c4f7c 100%);
  color: white;
}

.landing-section--light {
  background: #f5f7fa;
  color: #2d3748;
}

.landing-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.landing-services-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.landing-section-title {
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
}

.landing-section-title--dark {
  color: #2d3748;
}

.landing-section-icon {
  color: #f6b93b;
  flex-shrink: 0;
}


.landing-left-columns {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.landing-right-column {
  flex: 1;
  display: flex;
}


/* Other services section */
.landing-section-subtitle {
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 2rem 0;
  color: #4a5568;
}

.landing-grid--other {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.landing-other-services {
  padding: 2rem 0;
}

.landing-enquire-button {
  background: linear-gradient(135deg, #f39c6b 0%, #e8844a 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(243, 156, 107, 0.3);
}

.landing-enquire-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(243, 156, 107, 0.4);
  background: linear-gradient(135deg, #e8844a 0%, #d97542 100%);
}

.landing-enquire-button svg {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .landing-section {
    padding: 2rem 0;
  }

  .landing-container {
    padding: 0 1rem;
  }

  .landing-section-title {
    font-size: 1.5rem;
  }

  .landing-admin-grid {
    grid-template-columns: 1fr;
  }

  .landing-grid--other {
    grid-template-columns: 1fr;
  }

  .landing-enquire-button {
    width: 100%;
    justify-content: center;
  }
}
</style>
